import { combineReducers } from 'redux';

import auth from './auth';
import ui from './ui';
import cart from './cart';
import orders from './orders';
import checkout from './checkout';
import config from './config/reducers';
import analytics from './analytics';
import user from './user';
import { storeName as storeLocator, reducers as storeLocatorReducers } from './store-locator';
import { reducer as storeDetailReducer, storeName as storeDetails } from './store-details';
import search from './search';
import global from './global';
import wishlist from './wishlist';
import wishlists from './wishlists';
import product from './product';
import reviews from './reviews';
import notifyme from './notifyme';
import payment from './payment';
import order from './order';
import peerius from './peerius';
import address from './address';
import myAccount from './my-account';
import { reducers as social } from './social';
import minipdp from './minipdp';
import personaclick from './personaclick';
import powerReviews from './power-reviews';
import navigation from './navigation';
import modiface from './modiface';

export default function createReducer(dynamicReducers) {
    return combineReducers({
        auth,
        cart,
        orders,
        search,
        global,
        ui,
        checkout,
        config,
        analytics,
        myAccount,
        user,
        [storeLocator]: storeLocatorReducers,
        [storeDetails]: storeDetailReducer,
        ...dynamicReducers,
        wishlist,
        wishlists,
        notifyme,
        social,
        payment,
        order,
        product,
        reviews,
        peerius,
        address,
        minipdp,
        personaclick,
        powerReviews,
        navigation,
        modiface,
    });
}
